define('models/account',["require", "exports", "services/settings", "durandal/app", "common/string"], function (require, exports, configuration, app, String) {
    "use strict";
    var refreshTokenKey = "refreshToken";
    var accessTokenKey = "accessToken";
    var principalKey = "principal";
    var userNameKey = "userName";
    var employeeFilterKey = "employeeName";
    var requestStatusFilterKey = "requestStatusId";
    var expirationKey = "expiration";
    var applicationInitializedKey = "isinitialized";
    var rowCountKey = "rowcount";
    var Actor = (function () {
        function Actor() {
        }
        return Actor;
    }());
    exports.Actor = Actor;
    var Principal = (function () {
        function Principal() {
            this.organizationName = "ADDISON";
        }
        Principal.from = function (data, currentSystemLanguage) {
            var instance = new Principal();
            instance.id = data.id;
            instance.identityId = data.identityId;
            instance.identityName = data.identityName;
            instance.loginName = data.loginName;
            instance.email = data.email;
            instance.sessionId = data.sessionId;
            instance.organizationId = data.organizationId;
            instance.organizationName = data.organizationName;
            instance.taxAdvisorId = data.taxAdvisorId;
            instance.taxAdvisorName = data.taxAdvisorName;
            instance.memberType = data.memberType;
            instance.shouldChangePassword = data.shouldChangePassword;
            instance.shouldConfirmEmail = data.shouldConfirmEmail;
            instance.allowedFileTypes = data.allowedFileTypes;
            instance.sdnEnvironmentUrl = data.sdnEnvironmentUrl;
            instance.memberAccessList = data.memberAccessList;
            instance.hasAvatar = data.hasAvatar;
            instance.avatar = data.hasAvatar
                ? configuration.Settings.getServiceFor("portalstorage", "download/avatar/UserIdentity", "?disposition=online&avatarId=" + instance.identityId + "&sessionId=" + jQuery.base64.encode(instance.sessionId, true))
                : "/html/content/images/avatar.png";
            if (data.actor != null) {
                instance.actor = new Actor();
                instance.actor.name = data.actor.name;
            }
            instance.culture = this.GetUserOrDefaultCulture(data.culture, currentSystemLanguage);
            instance.organizationCountry = this.GetOrganizationOrDefaultCountry(data.organizationCountry, currentSystemLanguage);
            return instance;
        };
        Object.defineProperty(Principal, "current", {
            get: function () {
                var data = Session.principal;
                if (data == null)
                    return new Principal();
                return data;
            },
            set: function (data) {
                Session.principal = data;
            },
            enumerable: true,
            configurable: true
        });
        Principal.updateAvatar = function () {
            var user = this.current;
            user.avatar = configuration.Settings.getServiceFor("portalstorage", "download/avatar/NetworkMember", "?disposition=online&avatarId=" + user.id + "&sessionId=" + jQuery.base64.encode(user.sessionId, true)) + '&date=' + Date.now();
            this.current = user;
        };
        Principal.GetUserOrDefaultCulture = function (userDefinedCulture, currentSystemLanguage) {
            var culture = 'de-DE';
            if (!String.isNullOrEmpty(userDefinedCulture)) {
                culture = userDefinedCulture;
            }
            else {
                if (!String.isNullOrEmpty(currentSystemLanguage)) {
                    culture = currentSystemLanguage;
                }
            }
            return culture;
        };
        Principal.GetOrganizationOrDefaultCountry = function (userDefinedOrganizationCountry, currentSystemLanguage) {
            var country = 'DE';
            if (!String.isNullOrEmpty(userDefinedOrganizationCountry)) {
                country = userDefinedOrganizationCountry;
            }
            else {
                if (!String.isNullOrEmpty(currentSystemLanguage)) {
                    var options = currentSystemLanguage.split('-');
                    if (options != null && options.length > 1) {
                        country = options[1];
                    }
                }
            }
            return country;
        };
        return Principal;
    }());
    exports.Principal = Principal;
    var MemoryStorage = (function () {
        function MemoryStorage() {
            this._items = [];
        }
        MemoryStorage.prototype.setItem = function (key, data) {
            this._items[key] = data;
        };
        MemoryStorage.prototype.getItem = function (key) {
            return this._items[key];
        };
        MemoryStorage.prototype.clear = function () {
            this._items.length = 0;
        };
        return MemoryStorage;
    }());
    exports.MemoryStorage = MemoryStorage;
    var Session = (function () {
        function Session() {
        }
        Session.useMemoryStorage = function () {
            Session._storage = new MemoryStorage();
        };
        Session.setAuthentication = function (token, expiresIn) {
            Session._storage.setItem(accessTokenKey, token);
            var now = moment();
            var expiresOn = now.add(expiresIn, 'seconds');
            Session._storage.setItem(expirationKey, expiresOn);
            // raus springen
            window.setTimeout(function () { app.trigger("tokenTimeOut"); }, expiresIn * 1000);
        };
        Session.setupAppInsights = function () {
            // parse access token
            var token = this.accessToken;
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            var jwt = JSON.parse(jsonPayload);
            var memberGuid = "http://claims.addison.de/memberguid";
            var memberFlags = "http://claims.addison.de/memberflags";
            var orgGuid = "http://claims.addison.de/organizationguid";
            var parentGuid = "http://claims.addison.de/parentorganizationguid";
            var orgType = "http://claims.addison.de/organizationtype";
            var orgName = "http://claims.addison.de/organizationname";
            var memberType = "http://claims.addison.de/membertype";
            var userId = "http://claims.addison.de/identityguid";
            var isAAAEnabled = jwt["http://claims.addison.de/aaamemberid"] ? true : false;
            var organizationID = "http://claims.addison.de/organizationguid";
            var sessionId = "http://claims.addison.de/SessionId";
            // Set up application insights telemetry to include user and organisation properties
            var appInsights = window.appInsights;
            try {
                if (appInsights) {
                    if (appInsights.addTelemetryInitializer) {
                        appInsights.addTelemetryInitializer(function (envelope) {
                            var t = envelope.baseData;
                            t.properties = t.properties || {};
                            t.properties["auth_time"] = jwt["auth_time"];
                            t.properties["idp"] = jwt["idp"];
                            t.properties[memberGuid] = jwt[memberGuid];
                            t.properties[memberFlags] = jwt[memberFlags];
                            t.properties[orgGuid] = jwt[orgGuid];
                            t.properties[parentGuid] = jwt[parentGuid];
                            t.properties["OrganizationType"] = jwt[orgType];
                            t.properties["OrganizationName"] = jwt[orgName];
                            t.properties[memberType] = jwt[memberType];
                            t.properties["UserId"] = jwt[userId];
                            t.properties["exp"] = jwt["exp"];
                            t.properties["TokenSessionId"] = jwt["jti"];
                            t.properties["IsAAAEnabled"] = isAAAEnabled;
                            t.properties["PracticeName"] = jwt[orgType].toLowerCase() == "stb" ? jwt[orgName] : window.location.host.split('.')[0];
                            t.properties["URL"] = window.location.host !== null ? window.location.host : "";
                            t.properties["OrganizationID"] = jwt[organizationID] !== null ? jwt[organizationID] : "";
                            t.properties["SessionId"] = jwt[sessionId] !== null ? jwt[sessionId] : "";
                            t.properties["ProductName"] = "OneClick DashBoard";
                            t.properties["LoggingType"] = "WKUserPageView";
                            if (typeof screen !== "undefined") {
                                t.properties["ai.device.screenResolution"] = screen.width + "X" + screen.height;
                                t.properties["ai.device.locale"] = navigator.language || "unknown";
                            }
                            if (t.name == "Information Request Response Viewer | OneClick") {
                                t.name = "Data Collection";
                                t.properties["ProductName"] = "DC";
                                t.properties["User"] = jwt["name"];
                            }
                        });
                        appInsights.setAuthenticatedUserContext(jwt.identityId);
                        appInsights.trackTrace({ message: 'OneClick User Telemetry Information' });
                    }
                    else {
                        console.log("From setupAppInsights: TelemetryInitializer not initialized");
                    }
                }
                else {
                    console.log("From setupAppInsights: Application Insights SDK not found");
                }
            }
            catch (err) {
                // Mask any app insights initialisation failures to prevent bubbling up
                console.log("From setupAppInsights: Exception occured");
                console.log(err);
            }
        };
        Session.guardUserActivity = function () {
            this.startActivityMonitoring();
        };
        Object.defineProperty(Session, "isAuthenticated", {
            get: function () {
                return this.accessToken != null;
            },
            enumerable: true,
            configurable: true
        });
        Session.hasRefreshToken = function () {
            var token = this.refreshToken;
            return token != null;
        };
        Session.getAuthorizationHeader = function () {
            return configuration.Settings.getTokenType() + this.accessToken;
        };
        Session.getSessionId = function () {
            return Principal.current.sessionId;
        };
        Session.getTimestampedSessionId = function () {
            var now = new Date();
            var epochTicks = 621355968000000000;
            var ticksPerMillisecond = 10000;
            var ticks = epochTicks + (now.getTime() * ticksPerMillisecond);
            var sessionId = this.getSessionId();
            var result = sessionId + "_" + ticks;
            return jQuery.base64.encode(result, true);
        };
        Object.defineProperty(Session, "accessToken", {
            get: function () {
                return Session._storage.getItem(accessTokenKey);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "expiresAt", {
            get: function () {
                return moment(Session._storage.getItem(expirationKey));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "isExpired", {
            get: function () {
                var expiration = this.expiresAt;
                var now = moment();
                return now > expiration;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "loginName", {
            get: function () {
                return Session._storage.getItem(userNameKey);
            },
            set: function (data) {
                Session._storage.setItem(userNameKey, data);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "principal", {
            get: function () {
                var data = Session._storage.getItem(principalKey);
                if (data == null)
                    return null;
                return JSON.parse(data);
            },
            set: function (data) {
                Session._storage.setItem(principalKey, JSON.stringify(data));
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "rowCount", {
            get: function () {
                var rowCount = $.jStorage.get(rowCountKey);
                if (!rowCount || rowCount == 0)
                    rowCount = 25;
                return rowCount;
            },
            set: function (data) {
                $.jStorage.set(rowCountKey, data);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "refreshToken", {
            get: function () {
                return $.jStorage.get(refreshTokenKey);
            },
            set: function (data) {
                $.jStorage.set(refreshTokenKey, data);
            },
            enumerable: true,
            configurable: true
        });
        Session.clear = function () {
            var rowCount = this.rowCount;
            Session._storage.clear();
            if (Session.localStorageEnabled())
                $.jStorage.flush();
            this.rowCount = rowCount;
            // remove dom events
            if (this._intervalID !== 0) {
                this.stopActivityMonitoring();
            }
        };
        Session.localStorageEnabled = function () {
            try {
                return window.localStorage !== null;
            }
            catch (error) {
                return false;
            }
        };
        Session.stopActivityMonitoring = function () {
            document.removeEventListener("mousedown", this.onMouseDown);
            window.clearInterval(this._intervalID);
            this._intervalID = 0;
            this._lastUserAction = moment();
        };
        Session.startActivityMonitoring = function () {
            this.stopActivityMonitoring();
            document.addEventListener("mousedown", this.onMouseDown.bind(this));
            this._intervalID = window.setInterval(this.handleInterval.bind(this), 60000);
        };
        Session.handleInterval = function () {
            var diff = moment().diff(this._lastUserAction);
            if (moment.duration(diff).asMinutes() > 19) {
                this.stopActivityMonitoring();
                app.trigger("activityTimeOut");
            }
        };
        Object.defineProperty(Session, "employeeFilter", {
            get: function () {
                return Session._storage.getItem(employeeFilterKey);
            },
            set: function (data) {
                Session._storage.setItem(employeeFilterKey, data);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Session, "requestStatusFilter", {
            get: function () {
                return Session._storage.getItem(requestStatusFilterKey);
            },
            set: function (data) {
                Session._storage.setItem(requestStatusFilterKey, data);
            },
            enumerable: true,
            configurable: true
        });
        Session.onMouseDown = function (e) {
            this._lastUserAction = moment();
        };
        Session._storage = sessionStorage; // => nur für ADDISON-Kanzleisoftware anhand von NID ???  new MemoryStorage();
        Session._intervalID = 0;
        Session._lastUserAction = moment();
        return Session;
    }());
    exports.Session = Session;
    var Model;
    (function (Model) {
        var Password = (function () {
            function Password(value, repetition) {
                this.value = value;
                this.repetition = repetition;
            }
            return Password;
        }());
        Model.Password = Password;
        var MemberAccessControlItem = (function () {
            function MemberAccessControlItem() {
            }
            return MemberAccessControlItem;
        }());
        Model.MemberAccessControlItem = MemberAccessControlItem;
        var PasswordUpdate = (function () {
            function PasswordUpdate(currentPassword, value, repetition) {
                this.currentPassword = currentPassword;
                this.value = value;
                this.repetition = repetition;
            }
            return PasswordUpdate;
        }());
        Model.PasswordUpdate = PasswordUpdate;
    })(Model = exports.Model || (exports.Model = {}));
    var Requests;
    (function (Requests) {
        Requests.PortalBasicAuthenticationHeader = "Basic cG9ydGFsOmFpcF9zZWNyZXQ="; //portal:aip_secret
        Requests.IdentityPortalBasicAuthenticationHeader = "Basic Y3VzdG9tcG9ydGFsOmFpcF9zZWNyZXQ="; //customportal:aip_secret
        Requests.CodeBasicAuthenticationHeader = "Basic aW1wbGljaXRwb3J0YWw6YWlwX3NlY3JldA=="; //implicitportal:aip_secret
        var ProfileLoginRequest = (function () {
            function ProfileLoginRequest(domain, username, userId, profileId) {
                this.authenticationHeader = Requests.IdentityPortalBasicAuthenticationHeader;
                this.keepSignedIn = false;
                this.domain = domain;
                this.username = username;
                this.userId = userId;
                this.profileId = profileId;
            }
            ProfileLoginRequest.prototype.toJson = function () {
                var data = {
                    grant_type: "identityprofile",
                    url: this.domain,
                    username: this.username,
                    profileid: this.profileId,
                    userid: this.userId,
                    scope: "oneclick"
                };
                return data;
            };
            return ProfileLoginRequest;
        }());
        Requests.ProfileLoginRequest = ProfileLoginRequest;
        var LoginRequest = (function () {
            function LoginRequest(domain, username, password, clientNumber, keepSignedIn) {
                if (keepSignedIn === void 0) { keepSignedIn = false; }
                this.authenticationHeader = Requests.PortalBasicAuthenticationHeader;
                this.domain = domain;
                this.username = username;
                this.password = password;
                this.clientNumber = clientNumber;
                this.keepSignedIn = keepSignedIn;
                if (typeof (this.clientNumber) === "undefined")
                    this.clientNumber = "";
            }
            LoginRequest.prototype.buildLoginName = function () {
                if (this.username.indexOf("Secret:") >= 0) {
                    return this.username;
                }
                if (this.username.indexOf("SessionId:") >= 0) {
                    return this.username;
                }
                var loginName = this.domain;
                if (this.clientNumber !== "")
                    loginName += "\\" + this.clientNumber;
                loginName += "\\" + this.username;
                return loginName;
            };
            LoginRequest.prototype.toJson = function () {
                var data = {
                    grant_type: "password",
                    username: this.buildLoginName(),
                    password: this.password,
                    scope: "oneclick" + (this.keepSignedIn ? " offline_access" : "")
                };
                return data;
            };
            return LoginRequest;
        }());
        Requests.LoginRequest = LoginRequest;
        var CodeLoginRequest = (function () {
            function CodeLoginRequest(code, redirectUri) {
                this.authenticationHeader = Requests.CodeBasicAuthenticationHeader;
                this.code = code;
                this.redirectUri = redirectUri;
            }
            CodeLoginRequest.prototype.toJson = function () {
                var data = {
                    grant_type: "authorization_code",
                    code: this.code,
                    redirect_uri: this.redirectUri
                };
                return data;
            };
            return CodeLoginRequest;
        }());
        Requests.CodeLoginRequest = CodeLoginRequest;
    })(Requests = exports.Requests || (exports.Requests = {}));
});

